import { render } from "./MentorStudentList.vue?vue&type=template&id=059ba0d2"
import script from "./MentorStudentList.vue?vue&type=script&lang=js"
export * from "./MentorStudentList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__